import { useEffect } from "react";
import { X, ChevronLeft, ChevronRight } from "lucide-react";

export default function Lightbox({ open, items, index, onClose, onIndex }) {
  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (e.key === "Escape") onClose();
      else if (e.key === "ArrowLeft" && index > 0) onIndex(index - 1);
      else if (e.key === "ArrowRight" && index < items.length - 1) onIndex(index + 1);
    };
    document.addEventListener("keydown", handler);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", handler);
      document.body.style.overflow = "";
    };
  }, [open, index, items.length, onClose, onIndex]);

  if (!open || !items?.[index]) return null;
  const item = items[index];

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/90 fadein"
      onClick={onClose}
      data-testid="lightbox-overlay"
    >
      <button
        onClick={onClose}
        className="absolute top-4 right-4 w-11 h-11 rounded-full bg-white/10 backdrop-blur flex items-center justify-center text-white hover:bg-white/20 transition"
        data-testid="lightbox-close"
      >
        <X className="w-5 h-5" strokeWidth={1.5} />
      </button>

      {index > 0 && (
        <button
          onClick={(e) => { e.stopPropagation(); onIndex(index - 1); }}
          className="absolute left-4 w-12 h-12 rounded-full bg-white/10 backdrop-blur flex items-center justify-center text-white hover:bg-white/20 transition"
          data-testid="lightbox-prev"
        >
          <ChevronLeft className="w-6 h-6" strokeWidth={1.5} />
        </button>
      )}
      {index < items.length - 1 && (
        <button
          onClick={(e) => { e.stopPropagation(); onIndex(index + 1); }}
          className="absolute right-4 w-12 h-12 rounded-full bg-white/10 backdrop-blur flex items-center justify-center text-white hover:bg-white/20 transition"
          data-testid="lightbox-next"
        >
          <ChevronRight className="w-6 h-6" strokeWidth={1.5} />
        </button>
      )}

      <div
        className="max-w-5xl w-full px-6 max-h-[92vh] flex flex-col items-center"
        onClick={(e) => e.stopPropagation()}
      >
        <img
          src={item.src}
          alt={item.caption || ""}
          className="max-h-[78vh] max-w-full object-contain rounded-2xl"
          data-testid="lightbox-image"
        />
        <div className="mt-4 text-center text-white/90 max-w-2xl">
          {item.author && (
            <div className="text-[10px] tracking-[0.22em] uppercase text-white/60 mb-1">
              {item.author}
            </div>
          )}
          {item.caption && <div className="font-display text-xl">{item.caption}</div>}
          <div className="text-[10px] tracking-[0.22em] uppercase text-white/40 mt-2">
            {index + 1} / {items.length}
          </div>
        </div>
      </div>
    </div>
  );
}
